<template>
    <v-dialog v-model="openModal" max-width="290" content-class="confirm-delete-dialog">
        <v-card>
            <h4 class="question">{{ $page.props.lang.confirm_delete || "Confirm delete?" }}</h4>
            <div class="buttons">
                <v-btn color="primary" text @click="$emit('no')">{{ $page.props.lang.no || "No" }}</v-btn>
                <v-btn color="primary" text @click="$emit('yes')">{{ $page.props.lang.yes || "Yes" }}</v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ConfirmDelete",
    props: {
        open: Boolean
    },
    computed: {
        openModal: {
            get: function() {
                return this.open
            },
            set: function() {
                this.$emit('no')
                return false
            }
        }
    }
}
</script>